import { themeColorCtx } from '@/store/modules/theme';

// 	OSS 上传文件目录类型
// 'img': '图片',
// 'bcard': '名片',
// 'xls': '表格',
// 'doc': 'IRM公告',
// 'document': '路演相关文档',
// 'summary': '纪要',
// 'ppt': '路演演示文档',
// 'talkaudio': '即时聊天音频文件',
// 'audio': '路演音频',
// 'video': '路演视频',
// 'normal': '通用文件',
// 'transfer': 'IRM音频转写文件'
export const OSS_FILE_TYPE = [
	'img',
	'bcard',
	'xls',
	'doc',
	'document',
	'summary',
	'ppt',
	'talkaudio',
	'audio',
	'video',
	'normal',
	'transfer'
];

export const ECHARTS_COLORS = themeColorCtx.gradientColors;
